import { ITEM_TYPE_ENUM } from 'src/enums/company/financialInformation/financialItem';

export const financialRowColorDetector: Record<ITEM_TYPE_ENUM, string> = {
    [ITEM_TYPE_ENUM.ITEM]: 'rgba(255, 255, 255, 0.08)',
    [ITEM_TYPE_ENUM.SUBTITLE]: 'rgba(56, 97, 251, 0.08)',
    [ITEM_TYPE_ENUM.TITLE]: 'rgba(99, 197, 133, 0.14)',
    [ITEM_TYPE_ENUM.TOTAL]: 'rgba(253, 169, 44, 0.12)',
    [ITEM_TYPE_ENUM.SUBTOTAL]: 'rgba(220, 78, 78, 0.11)',
};
